import Vue from 'vue'
// 单个按钮的防重复提交
Vue.directive('noMoreClick', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      // 判断是否rules交易已经添加了置灰操作，若已经置灰则不进行处理
      if (el.disabled) {
        return false
      }

      // 按钮没有被置灰，则置灰后3秒后恢复
      el.classList.add('is-disabled')
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
        el.classList.remove('is-disabled')
      }, 2000)
    })
  }
})
// 获得元素的兄弟元素并置灰
function setSiblingsDisabled(el) {
  let p = el.parentNode.children
  let plength = p.length
  for (let i = 0; i < plength; i++) {
    if (p[i] !== el) {
      // 兄弟节点也添加上置灰炒作
      p[i].classList.add('is-disabled')
      p[i].disabled = true
    }
  }
}
// 获得元素的兄弟元素并恢复
function setSiblingsEnabled(el) {
  let p = el.parentNode.children
  let plength = p.length
  for (let i = 0; i < plength; i++) {
    if (p[i] !== el) {
      // 兄弟节点也添加上置灰炒作
      p[i].classList.remove('is-disabled')
      p[i].disabled = false
    }
  }
}
// 按钮组的防重复提交
Vue.directive('noMoreItemClick', {
  inserted(element, binding) {
    let array = element.children[0].children
    let length = array.length
    for (let index = 0; index < length; index++) {
      const el = array[index]
      el.addEventListener('click', e => {
        // 判断是否rules交易已经添加了置灰操作，若已经置灰则不进行处理
        if (el.disabled) {
          return false
        }

        // 按钮没有被置灰，则置灰后3秒后恢复
        el.classList.add('is-disabled')
        el.disabled = true
        // 遍历兄弟节点,置灰其按钮
        setSiblingsDisabled(el)
        setTimeout(() => {
          el.disabled = false
          el.classList.remove('is-disabled')
          setSiblingsEnabled(el)
        }, 3000)
      })
    }
  }
})

//数字输入框自动补全
Vue.directive("autoCompletion", {
  update(el, binding, vnode) {
    let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
    ele.oninput = function () {
      let val = ele.value;
      val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      val = val.replace(/^\./g, ""); //验证第一个字符是数字
      val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      val = val.replace(/^(-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
      if(val.length>1&&val.slice(0,1)=='0'&&val.slice(1,2)=='0'){
        val = val.slice(0,1)
      }
      if(binding.value){
        if(val.indexOf('.')>0){
          if(val.slice(0,val.indexOf('.')).length>binding.value){
            let stu = val.slice(val.indexOf('.'))
            val = val.slice(0,binding.value)+stu
          }
        }else{
          val = val.slice(0,binding.value)
        }
      }
      ele.value = val
      if(ele._value!=ele.value){
        ele._value = val
        ele.dispatchEvent(new Event('input'))
      }
    }
    ele.onchange = function () {
      let val = ele.value;
      if(val.indexOf('.')>0&&(val.slice(val.indexOf('.')+1)).length==1){
        val = val+'0'
      }else if(val.indexOf('.')<0&&val!=''){
        val = val+'.00'
      }else if(val.indexOf('.')+1==val.length&&val!=''){
        val = val+'00'
      }
      if(val == '0.00'){
        ele.value = ''
        ele._value = ''
      }else{
        ele.value = val
        if(ele._value!=ele.value){
          ele._value = val
          ele.dispatchEvent(new Event('input'));
        }
      }
    }
  }
})

//判断手机电话限制输入
Vue.directive("phoneLimit", {
  update(el, binding, vnode) {
    let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
    ele.oninput = function () {
      let val = ele.value;
      val = val.replace(/[^\d-]/g, ""); //清除"数字"和"-"以外的字符
      if(val.length>4&&val.indexOf('-')<0){
        val = val.replace(/[^\d]/g, ""); //清除"数字"以外的字符
        val = val.slice(0,11)
      }else{
        val = val.slice(0,20)
      }
      ele.value = val;
      ele._value = val;
    }
  }
})
